$(document).ready(() => {
  const $rows = $('[data-comparison-row]');
  $rows.each((i, row) => {
    const $children = $(row).children();
    if ($children.length === 2 && $children.last().text().replace(/(?:(?:\r\n|\r|\n)\s*){2}/gm, '') === '-') {
      $(row).remove();
    }
  });
});
